import { appTypes } from './app.types';
import { handleDecrementTimer } from './app.utils';
import { getCookie } from 'utils';

// TODO: move this func to adapter functions
const getInitialLocale = () => {
  // if(localStorage.getItem('raychat_dashboard_locale')) return localStorage.getItem('raychat_dashboard_locale');
  // return "fa"
  const clientLocale = getCookie('raychat_dashboard_client_locale');
  const serverLocale = getCookie('raychat_dashboard_server_locale');

  if (clientLocale) return clientLocale;
  if (serverLocale) return serverLocale;
  return 'fa';
};

export const INITIAL_STATE = {
  signupWizardActivePageName: 'signup',
  unregisteredUser: {},
  widgetCode: '',
  verificationCodeTimer: 120,
  isTimerStarted: false,
  mobileNumber: '',
  isMobileValidated: true,
  isWidgetReady: false,
  locale: getInitialLocale(),
};
const appReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case appTypes.SET_SIGNUP_WIZARD_ACTIVE_PAGE_NAME:
      return {
        ...state,
        signupWizardActivePageName: action.payload,
      };
    case appTypes.SET_AS_UNREGISTERED_USER:
      return {
        ...state,
        unregisteredUser: action.payload,
      };
    case appTypes.SET_USER_OTP_TOKEN:
      return {
        ...state,
        unregisteredUser: {
          ...state.unregisteredUser,
          otpToken: action.payload,
        },
      };
    case appTypes.SET_WIDGET_CODE:
      return {
        ...state,
        widgetCode: action.payload,
      };
    case appTypes.SET_WIDGET_TOKEN:
      return {
        ...state,
        widgetToken: action.payload,
      };
    case appTypes.DECREMENT_VERIFICATION_CODE_TIMER:
      return handleDecrementTimer({ prevState: state });
    case appTypes.SET_VERIFICATION_CODE_TIMER_STATUS:
      return {
        ...state,
        isTimerStarted: action.payload,
        verificationCodeTimer: 120,
      };
    case appTypes.SET_MOBILE_NUMBER:
      return {
        ...state,
        mobileNumber: action.payload,
      };
    case appTypes.SET_IS_MOBILE_VALIDATED:
      return {
        ...state,
        isMobileValidated: action.payload,
      };
    case appTypes.SET_IS_WIDGET_READY:
      return {
        ...state,
        isWidgetReady: action.payload,
      };
    case appTypes.SET_LOCALE:
      return {
        ...state,
        locale: action.payload,
      };

    default:
      return state;
  }
};
export default appReducer;
